module.exports = __webpack_public_path__ + "static/media/plus.3b6cdee3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/scenes/AppFrame/images/icons/plus.svg
// module id = 281
// module chunks = 0